import apiAdjustment from '@/api/stockAdjustment';
import apiOption from '@/api/option';
import apiStockist from '@/api/ecommerce/stockist';
import apiStock from '@/api/ecommerce/stock';

const defaultState = () => ({
	listAdjustment: [],
	detailSA: {},
	adjustmentPagination: '',
	listProduct: [],
	listAdjustmentMB: [],
	detailSAMB: {},
	adjustmentPaginationMB: '',
	listProductMB: [],
	listStockist: [],
	response: {
		code: '',
		message: ''
	},
	alertMultiple: [],
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setAdjustment(state, data) {
		state.listAdjustment = data.data
		state.adjustmentPagination = data.pagination;
	},
	setAdjustmentMB(state, data) {
		state.listAdjustmentMB = data.data
		state.adjustmentPaginationMB = data.pagination;
	},
	setDetailSA(state, data) {
		state.detailSA = data
	},
	setDetailSAMB(state, data) {
		state.detailSAMB = data
	},
	setProduct(state, data) {
		state.listProduct = data.map( (el) => {
			el.quantity = 1
			return el
		});
	},
	setProductMB(state, data) {
		state.listProductMB = data.map( (el) => {
			el.quantity = 1
			return el
		});
	},
	setStockist(state, data){
		state.listStockist = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataAdjustment(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getAdjustment({ commit }, params) {
		return new Promise((resolve) => {
			apiAdjustment.getAdjustment(params).then(({ data: { data } }) => {
				commit('setAdjustment', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setAdjustment', { data: [], pagination: {} });
			});
		});
	},
	getDetailSA({ commit, dispatch }, params) {
		apiAdjustment.getDetailSA(params).then(({ data: { data } }) => {
			commit('setDetailSA', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailSA', { data: [] });
		});
	},
	getOptionProduct({ commit }) {
		apiOption.getOptionProductToAdjust().then(({ data: { data } }) => {
			commit('setProduct', data.results);
		}).catch(() => {
			commit('setProduct', []);
		});
	},
	getAdjustmentMB({ commit }, params) {
		return new Promise((resolve) => {
			apiStock.getAdjustmentMB(params).then(({ data: { data } }) => {
				commit('setAdjustmentMB', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setAdjustmentMB', { data: [], pagination: {} });
			});
		});
	},
	getDetailSAMB({ commit, dispatch }, params) {
		apiStock.getDetailSAMB(params).then(({ data: { data } }) => {
			commit('setDetailSAMB', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailSAMB', { data: [] });
		});
	},
	getOptionProductMB({ commit }, params) {
		apiStockist.getStockistStockWithId(params).then(({ data: { data } }) => {
			commit('setProductMB', data.results);
		}).catch(() => {
			commit('setProductMB', []);
		});
	},
	getStockist({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiStockist.getDataStockist(params).then(({ data: { data }  }) => {
				resolve(data.results)
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject()
			});
		})
	},
	async exportAdjustment({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiAdjustment.exportAdjustment(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Penyesuaian Stok'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportAdjustmentMB({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiStock.exportAdjustmentMB(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {																																																																																																							
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Penyesuaian Stok'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async createAdjustment({ commit, dispatch }, params) {
		await apiAdjustment.createAdjustment(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal membuat Penyesuaian Stok'
			}, { root: true });
		});
	},
	async createAdjustmentMB({ commit, dispatch }, params) {
		await apiStock.createAdjustmentMB(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal membuat Penyesuaian Stok'
			}, { root: true });
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};